<template>
  <UploadFileDialog ref="uploadFile" :open="value" :isUploadLoading="getUploadAllEntriesLoading" @upload="upload" @close="close"></UploadFileDialog>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from 'vuex';

  import UploadFileDialog from '@/components/Globals/UploadFileDialog';

  export default {  
    components: { UploadFileDialog },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      ...mapGetters('ledger/OnDashboard', ['getUploadAllEntriesLoading', 'getUploadAllEntriesError', 'getAttemptId']),
    },

    methods: {
      ...mapMutations('ledger/OnDashboard', ['CLEAR_ATTEMPT_ID']),
      ...mapActions('ledger/OnDashboard', ['uploadAllEntries', 'fetchOnAttempts']),

      async upload(file) {
        await this.uploadAllEntries({ id: this.getAttemptId, all_entries: file });

        if (!this.getUploadAllEntriesError) {
          this.fetchOnAttempts();
          this.$refs.uploadFile.close();
        }
      },

      close() {
        this.CLEAR_ATTEMPT_ID();
        this.$emit('input', false);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>